angular.module("vouchers").filter("voucherFilter", () => {
    return function(items, filter) {
        let filtered = [];

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (
                typeof item.Holder === "undefined"
                || (filter.year != "" && item.date_created.substr(0, 4) != filter.year)
                || (!filter.used && item.used == 1)
                || (!filter.outstanding && item.used == 0)
                || (!filter.paid && item.paid == 1)
                || (!filter.unpaid && item.paid == 0)
                || (!filter.billable && (item.free === null || item.free == 0))
                || (!filter.free && item.free == 1)
                || (typeof filter.alliance !== "undefined" && !filter.alliance && item.isAlliance == 1)
            ) {
                continue;
            }

            filtered.push(item);
        }

        return filtered;
    };
});
